function QueueDocs() {
  return (
    <>
      <div className="card">
        <div className="card-header">Queue Information</div>
        <div className="card-body">
          <ul className="my-2">
            <li>When the queue is paused, new jobs cannot be added.</li>
            <li>
              Pausing or emptying the queue will clear all pending jobs, but the
              job currently being processed will continue until completion.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default QueueDocs;
